module.exports = __webpack_public_path__ + "img/Mozambique.01d6c27e.gif";